import React from 'react';
interface StatusPillProps {
  status: 'active' | 'paused' | 'cancelled';
  children: React.ReactNode;
}
export function StatusPill({
  status,
  children
}: StatusPillProps) {
  const styles = {
    active: 'bg-green-500/10 text-green-400 border-green-500/20',
    paused: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
    cancelled: 'bg-red-500/10 text-red-400 border-red-500/20'
  };
  return <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${styles[status]}`} data-id="element-76">
      {children}
    </span>;
}